import { render, staticRenderFns } from "./ContractBalance.vue?vue&type=template&id=875df786"
import script from "./ContractBalance.vue?vue&type=script&lang=js"
export * from "./ContractBalance.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports